import {createActions} from 'client/framework';

const normalActions = [
  'PAGE_CHANGED',
  'SET_ACTIVE_PAGE',
  'SET_PAGE_LIST_WINDOW_INDICES',
  'RESET_STORE'
];

export default createActions(null, normalActions);
